import { NgModule } from '@angular/core';
import { OccProductSearchPageNormalizer } from '@spartacus/core';
import { CustomOccProductSearchPageNormalizer } from './converters';

@NgModule({
  providers: [
    {
      provide: OccProductSearchPageNormalizer,
      useExisting: CustomOccProductSearchPageNormalizer,
    },
  ],
})
export class CatalogUtilsModule {}
